import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getSearchSuggestionsQueryKey } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/__internal__/getSearchSuggestionsQueryKey";
import { useSearchSuggestionsThrottledQueryString } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/__internal__/useSearchSuggestionsThrottledQueryStringContext";
import searchSuggestionsV2 from "@faire/web-api--source/api/v2/search/suggestions/post";
import { ISearchSuggestionRequest } from "@faire/web-api--source/indigofair/data/ISearchSuggestionRequest";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
export var useSearchSuggestionsQuery = function(queryString, options) {
    var userQueryString = useSearchSuggestionsThrottledQueryString();
    var query = queryString !== null && queryString !== void 0 ? queryString : userQueryString;
    var result = useQuery(_object_spread({
        queryKey: getSearchSuggestionsQueryKey(query),
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal;
                return _ts_generator(this, function(_state) {
                    signal = param.signal;
                    return [
                        2,
                        searchSuggestionsV2(ISearchSuggestionRequest.build({
                            query: query
                        }), {
                            signal: signal
                        }).then(function(response) {
                            return _object_spread_props(_object_spread({}, response), {
                                query: query
                            });
                        })
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        placeholderData: keepPreviousData
    }, options));
    return result;
};
